import axios from "axios";
import { Buffer } from "buffer";

const stoneGridUrl = "https://sandbox.stonegridusa.com/stoneapp.openapi";
const stoneGridApiUrl = "https://sandbox.stonegridusa.com/stoneapp.openapi/v3/";

const saRequest = async (
  creds,
  baseURL,
  url,
  params = {},
  extraHeaders = {}
) => {
  try {
    // debugger;
    console.log({ creds });
    const username = "lucas";
    const password = "lucas2024";
    const clientId = "hotsauce";
    const clientSecret = "ACA44ED9-0739-4C41-B733-AE47E3A8EA6E";
    const clientCredentials = Buffer.from(
      `${clientId}:${clientSecret}`
    ).toString("base64");

    const loginRes = await axios.post(
      "https://sandbox.stonegridusa.com/stoneapp.openapi/token",
      new URLSearchParams({
        grant_type: "password",
        username: username,
        password: password,
      }).toString(), // Convert URLSearchParams to string
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Basic ${clientCredentials}`,
        },
      }
    );

    // debugger;
    const accessToken = loginRes.data.access_token;

    let headers = {};
    if (!Object.keys(extraHeaders).length) {
      headers = {
        Authorization: `Bearer ${accessToken}`,
      };
    } else {
      headers = {
        ...Object.assign({}, extraHeaders),
      };
    }

    const options = {
      baseURL,
      url: url,
      headers,
      ...params,
    };
    console.log({ options });

    const response = await axios(options);
    return response.data;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
      if (error.response.data.details) {
        console.log(error.response.data.details);
      }
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log("Error", error.message);
    }
    throw error;
  }
};

const getJob = async (creds, jobId) => {
  try {
    let response = await saRequest(
      creds,
      stoneGridUrl,
      `/quotes/data?quoteNo=${jobId}`,
      {
        method: "GET",
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const postData = async (creds, data) => {
  debugger;
  const client = data.details.client;
  const accepted = data.details.cart.accepted;

  const formattedData = accepted.map((x) => ({
    JobID: data.details.client.job,
    AccountID: 0, // todo -- ask about this
    CustomerID: client.id, // -- todo ask about this
    OfferingName: x.sales_option,
    OfferingQty: data.details.cart.quantity[x.id],
    OfferingPrice: `$${(x.price / 100).toFixed(2)}`,
    OfferingUnit: x.unit_type,
    ItemType: 0, // todo -- ask about this
  }));

  try {
    let response = await saRequest(creds, stoneGridApiUrl, "/job/AddItem", {
      method: "POST",
      formattedData,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export default {
  getJob,
  postData,
};
